// Slovenské dvojče locale/cs/whispererRender.js.
import { plural } from '../plural.js';

export default {
  suggests: 'Našepkávané dopyty',
  popularQueries: 'Najhľadanejšie',
  products: 'Produkty',
  popularProducts: 'Populárne produkty',
  hint: '↑ ↓ pohyb · Enter otvorí',
  cart: 'Do košíka',
  top: 'Top',
  groups: {
    cat: 'Kategórie',
    brand: 'Značky',
    article: 'Články',
    page: 'Stránky',
  },
  resultsCount: (total) => total + ' ' + plural(total, ['výsledok', 'výsledky', 'výsledkov']),
  resultsCta: (total) => {
    const prefix = total === 1 ? 'Zobraziť ' : total >= 2 && total <= 4 ? 'Zobraziť všetky ' : 'Zobraziť všetkých ';
    return prefix + total + ' ' + plural(total, ['výsledok', 'výsledky', 'výsledkov']);
  },
};
